import { useState } from 'react';
import { send } from './api.js';
import { t } from './i18n.js';
import { browserZone, exactLocalToIso } from './time.js';

/** Exceptions update the finite series and send a fresh invitation revision. */
export function TeamOccurrence({
  calendarId,
  event,
  onChange,
}: {
  calendarId: string;
  event: any;
  onChange: () => Promise<void>;
}) {
  const [open, setOpen] = useState(false),
    [start, setStart] = useState(''),
    [end, setEnd] = useState(''),
    [busy, setBusy] = useState(false),
    [error, setError] = useState('');
  const update = async (move: boolean) => {
    setBusy(true);
    setError('');
    try {
      const a = move ? exactLocalToIso(start, browserZone()) : undefined,
        b = move ? exactLocalToIso(end, browserZone()) : undefined;
      if (move && (!a || !b)) throw new Error(t('Date ou heure invalide.'));
      await send(
        `/team-calendars/${calendarId}/events/${event.id}`,
        {
          title: event.title,
          description: event.description,
          resourceId: event.resourceId ?? null,
          start: event.seriesStart,
          end: event.seriesEnd,
          revision: event.revision,
          ...event.recurrence,
          exceptions: [
            ...event.recurrence.exceptions.filter(
              (x: any) => Date.parse(x.originalStart) !== Date.parse(event.occurrenceStart),
            ),
            { originalStart: event.occurrenceStart, ...(move ? { start: a, end: b } : {}) },
          ],
        },
        'PUT',
      );
      setOpen(false);
      await onChange();
    } catch (e: any) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="pro-form">
      <p>
        {t(
          'Événement récurrent : les modifications ci-dessous concernent uniquement cette occurrence.',
        )}
      </p>
      <button type="button" disabled={busy} onClick={() => void update(false)}>
        {t('Annuler cette occurrence')}
      </button>
      <button type="button" disabled={busy} onClick={() => setOpen(!open)}>
        {t('Déplacer cette occurrence')}
      </button>
      {open && (
        <>
          <label>
            {t('Nouveau début')}
            <input type="datetime-local" value={start} onChange={(e) => setStart(e.target.value)} />
          </label>
          <label>
            {t('Nouvelle fin')}
            <input type="datetime-local" value={end} onChange={(e) => setEnd(e.target.value)} />
          </label>
          <button type="button" disabled={busy || !start || !end} onClick={() => void update(true)}>
            {t('Enregistrer le déplacement')}
          </button>
        </>
      )}
      {error && <p role="alert">{error}</p>}
    </section>
  );
}
